module.exports = __webpack_public_path__ + "img/Webで学ぶ JavaScript 2020_3_8.f6acd53d.jpeg";